import connection from './connection.js'

const list = async function (callback) {
  const url = '/admin/logistics/list'
  let {
    error,
    data
  } = await connection.query(url)
  if (callback) callback(error, data)
}

const detail = async function (itemId, callback) {
  const url = '/admin/logistics/detail'
  let {
    error,
    data
  } = await connection.query(url, {
    itemId: itemId
  })
  if (callback) callback(error, data)
}

export default {
  list: list,
  detail: detail
}